import styled from 'styled-components/macro';
import { fonts } from 'style/fonts';

export const ShowMoreLabel = styled.label`
  cursor: pointer;
  font-size: 0.8333rem;
  font-family: ${fonts.LLBrown.BOLD};
  padding: 0.2em;
`;
